import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';
import DropCap from '../Shared/DropCap';

const TopText = () => {
	const { data: {content} } = useContext(Context);

	return (
		<div className='chapter-3__top-text'>
			<div className='chapter-3__top-text__container main-grid'>
				<div className='main-grid__margin'></div>
				<div className='main-grid__body'>
					<p className='chapter-3__top-text__title'>{content.chapters.third.intro.title}</p>
				</div>
				<div className='main-grid__margin'></div>
			</div>
			<DropCap 
				paragraph={content.chapters.third.intro.paragraphs}
				elClass='chapter-3__drop-cap'
			/>
		</div>
	)
};

export default TopText;